import React, { useState } from 'react';
import i18n from "i18n";

import ErrorBag from '@shared/components/base/ErrorBag';
import { platformLogin } from '../../../features/auth/api';

function normalizeErrors(err) {
  const data = err?.response?.data;
  if (data && typeof data === 'object') return data;
  return { message: [err?.message || 'Request failed'] };
}

function LoginForm({ onSuccess }) {
  const [errors, setErrors] = useState({});
  const [email_address, setEmail_address] = useState(null);
  const [password, setPassword] = useState(null);
  const [remember, setRemember] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name === 'email_address') {
      setEmail_address(value);
    } else if (name === 'password') {
      setPassword(value);
    } else if (name === 'remember') {
      setRemember(value);
    }
  };

  const validate = () => {
    const inputErrors = {};
    let isValid = true;
    if (!email_address) {
      isValid = false;
      inputErrors["email"] = ["Please enter your email address"];
    }
    if (!password) {
      isValid = false;
      inputErrors["password"] = ["Please enter your password"];
    }
    setErrors(inputErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) return false;

    setLoader(true);
    setErrors({});
    try {
      const payload = await platformLogin({
        email_address,
        password,
        remember_me: remember,
      });
      onSuccess?.(payload);
      return true;
    } catch (err) {
      const normalized = normalizeErrors(err);
      // Prefer backend field errors when present
      const next = normalized?.errors && typeof normalized.errors === 'object' ? normalized.errors : normalized;
      setErrors(next || { message: ["Request failed"] });
      return false;
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="w-full">
      <form
        className="w-full"
        onSubmit={handleSubmit}
      >
        <fieldset disabled={loader} className="disabled:opacity-50">
          <div className="w-full mb-4">
            <ErrorBag key="error_message" target="message" errors={errors} />
          </div>
          <div className="w-full mb-4">
            <input
              className="w-full px-4 py-3 text-base text-gray-900 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0b8e36] focus:border-[#0b8e36] transition-colors placeholder:text-gray-500"
              id="form-email-login"
              required
              type="email"
              name="email_address"
              placeholder={i18n.t('e_mail')}
              value={email_address || ''}
              onChange={handleInputChange}
            />
            <ErrorBag key="error_email_address" target="email_address" errors={errors} />
          </div>
          <div className="w-full mb-4">
            <input
              className="w-full px-4 py-3 text-base text-gray-900 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0b8e36] focus:border-[#0b8e36] transition-colors placeholder:text-gray-500"
              id="form-login-password-1"
              required
              type="password"
              name="password"
              placeholder={i18n.t('password')}
              value={password || ''}
              onChange={handleInputChange}
            />
            <ErrorBag key="error_password" target="password" errors={errors} />
          </div>
          <label className="flex items-center mb-4 cursor-pointer select-none">
            <input
              className="w-4 h-4 text-[#0b8e36] border-gray-300 rounded focus:ring-[#0b8e36] focus:ring-2 cursor-pointer"
              name="remember"
              value="checkbox-1"
              type="checkbox"
              checked={remember}
              onChange={handleInputChange}
            />
            <span className="ml-2 text-sm text-gray-700">{i18n.t('remember_me')}</span>
          </label>
          <button
            className="w-full px-6 py-3 bg-[#0b8e36] text-white font-medium rounded-md hover:bg-[#086a28] focus:outline-none focus:ring-2 focus:ring-[#0b8e36] focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed min-h-[44px] flex items-center justify-center"
            type="submit"
            disabled={loader}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleSubmit(e);
            }}
          >
            {loader ? i18n.t('loading') : i18n.t('log_in')}
          </button>
        </fieldset>
      </form>
    </div>
  );
}

export default LoginForm;

